import {
  Box,
  Button,
  Flex,
  HStack,
  Select,
  Stack,
  StackProps,
  Text,
} from '@chakra-ui/react'
import { useStore } from '@contexts/store'
import React, { useState } from 'react'
import { FiFilter } from 'react-icons/fi'

export const useProductSortFilter = () => {
  const [productFilter, setProductFilter] = useState<Record<string, string>>({
    sort: '-created',
  })

  const handleProductFilter = (e: string) => {
    let sort = '-created'
    let onSale = false
    switch (e) {
      case 'latest':
        sort = '-created'
        break
      case 'lowest':
        sort = '+price'
        break
      case 'highest':
        sort = '-price'
        break
      case 'a-z':
        sort = 'name'
        break
      case 'z-a':
        sort = '-name'
        break
      case 'onSale':
        onSale = true
        break
      default:
        sort = '-created'
        break
    }
    setProductFilter((prev: any) => ({ ...prev, sort: sort, onSale }))
  }

  return { productFilter, handleProductFilter }
}

interface ProductSortFilterProps {
  handleProductFilter: (e: string) => void
  styleProps?: StackProps
}

const ProductSortFilter = ({
  handleProductFilter,
  styleProps,
}: ProductSortFilterProps) => {
  const { openDrawer, setDrawerView } = useStore()

  function openAdvancedFilters() {
    setDrawerView('ADVANCED_FILTERS_DRAWER')
    return openDrawer()
  }

  return (
    <Stack
      direction={'row'}
      spacing={{ md: '1' }}
      display="inline-flex"
      flexWrap="wrap"
      w={{ base: 'full', md: 'auto' }}
      align="center"
      justifyContent={{ base: 'space-between', md: 'end' }}
      {...styleProps}
    >
      <Button
        bg="transparent"
        fontWeight="400"
        fontSize="14px"
        top={{ md: '2.5px' }}
        leftIcon={<Box as={FiFilter} color="brand" fontSize="14px" />}
        onClick={openAdvancedFilters}
      >
        Filters
      </Button>
      <Flex
        alignItems="center"
        position="relative"
        ml="3.5"
        bottom={['2px', '0px']}
      >
        <Text
          as="span"
          fontSize="14px"
          position="relative"
          top="3px"
          width="80px"
        >
          Sort by:
        </Text>
        <Select
          border="none"
          fontSize="14px"
          cursor="pointer"
          _focus={{ ring: '0', border: 'none' }}
          onChange={(e: any) => handleProductFilter(e.target.value)}
        >
          <option value="latest">Latest</option>
          <option value="lowest">Price: Low to High</option>
          <option value="highest">Price: High to Low</option>
          <option value="onSale">Price: On Sale</option>
          <option value="a-z">A - Z</option>
          <option value="z-a">Z - A</option>
        </Select>
      </Flex>
    </Stack>
  )
}

export default ProductSortFilter
